import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 4.5C13.2426 4.5 14.25 3.49264 14.25 2.25C14.25 1.00736 13.2426 0 12 0C10.7574 0 9.75 1.00736 9.75 2.25C9.75 3.49264 10.7574 4.5 12 4.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.75 7V5.5H2.25V7L8.75 8.75L9 12L4.75 22.75L6.25 23.5L11.995 14.5H12.005L17.75 23.5L19.25 22.75L15 12L15.25 8.75L21.75 7Z"}}]};

const AccessibilityFilled = Vue.extend<IconProps>({
  name: 'AccessibilityFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'accessibility-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AccessibilityFilled;
